<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <div class="lv-checkbox" [ngClass]="{'lv-error-state': !!getError()}">
      <div>
        <mat-checkbox [ngModel]="uiArtefakt.WertEingabe"
                      [name]="uiArtefakt.Identifikator" [id]="uniqueId"
                      #checkbox="ngModel" (change)="changeCheckbox($event.checked)"
                      [disabled]="isDisabled">
          <span *ngIf="!!uiArtefakt.Text" [innerHTML]="uiArtefakt.Text"></span>
        </mat-checkbox>
        <input [name]="'lvHidden'" [(ngModel)]="hiddenInputmodel" class="lv-hidden-form" [required]="uiArtefakt.PflichtfeldJN">
      </div>
      <div>
        <lv-label-tooltip [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                          [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                          [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                          (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
      </div>
    </div>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>

    <mat-error class="lv-error-meldung-style" [ngClass]="uiArtefakt.BreiteInPixel"
               *ngIf="getError() as error" (click)="onErrorClick()">
      <div class="lv-control-error"
           [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
    </mat-error>
  </div>
</form>
